// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * POST /users/me/email-change (spec 20261028-132000 AC-6): when the code sent to the new address expires. The code
 * itself comes back only in development, where the login's code is shown on screen too.
 */
export const emailChangeRequestedSchema = z
    .object({
        expiresAt: z.string(),
        devCode: z
            .string()
            .regex(/^\d{6}$/)
            .optional(),
    })
    .strict()
export type EmailChangeRequested = z.infer<typeof emailChangeRequestedSchema>

/** POST /users/me/email-change/confirm: the address the account has now. */
export const emailChangeConfirmedSchema = z
    .object({
        email: z.string(),
    })
    .strict()
export type EmailChangeConfirmed = z.infer<typeof emailChangeConfirmedSchema>
